'use client'

import * as React from 'react'

import { Cross1Icon, HamburgerMenuIcon } from '@radix-ui/react-icons'
import { useSelectedLayoutSegment } from 'next/navigation'
import { useToggleState } from '~/hooks/use-toggle-state'
import { ButtonLink } from '~/sotano-kit/primitives/button'
import { clsx } from 'clsx'
import { loginRoute } from '~/constants/routing'
import { useUserStore } from '~/app/_store/user-store'
import { HeaderMiddleLinksFragment } from './links'

export const MobileMenu = ({
  headerLinks,
}: {
  headerLinks: HeaderMiddleLinksFragment[]
}) => {
  const { handleOff, handleToggle, isOn } = useToggleState()
  const selectedLayoutSegment = useSelectedLayoutSegment()
  const optimisticUser = useUserStore((s) => s.optimisticUser)

  React.useEffect(() => {
    handleOff()
  }, [selectedLayoutSegment, handleOff])

  return (
    <div>
      <button
        className="p-3 flex items-center justify-center text-dark-bright"
        onClick={handleToggle}
      >
        {isOn ? <Cross1Icon /> : <HamburgerMenuIcon />}
      </button>
      {isOn && (
        <div
          className={clsx(
            'absolute pt-2 bg-[#0E0E0E] top-[theme(height.header)] px-mobile-px left-0 w-full space-y-6 overflow-visible max-h-[70vh] pb-4 border-b border-dark-border-solid',
            'before:content-[""] before:w-screen before:absolute before:bg-[#0E0E0E] before:h-header before:left-1/2 before:-translate-x-1/2 before:-translate-y-8 before:pointer-events-none before:-z-10'
          )}
        >
          <div className="flex flex-col space-y-1">
            {headerLinks.map((link) => {
              const isActive = selectedLayoutSegment === link.href.split('/')[1]

              return (
                <ButtonLink
                  key={link._id}
                  unstyled
                  focusStyled
                  className={clsx(
                    'inline-flex items-center py-1 text-lg text-dark-muted tracking-tight',
                    isActive && '!text-dark-bright'
                  )}
                  href={link.href}
                >
                  {link._title}
                </ButtonLink>
              )
            })}
          </div>
          <div className="flex flex-col space-y-2">
            <ButtonLink
              href={optimisticUser ? '/' : loginRoute}
              intent={optimisticUser ? 'primary' : 'secondary'}
              size="large"
              suppressHydrationWarning
            >
              {optimisticUser ? 'Dashboard' : 'Log In'}
            </ButtonLink>
            {!optimisticUser && (
              <ButtonLink href={loginRoute} size="large">
                Sign Up
              </ButtonLink>
            )}
          </div>
        </div>
      )}
    </div>
  )
}
